import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { PENDING_DISCLOSURE_CHIP_TITLE } from '../../LoanCicHistory.constants';

export const PENDING_CHIP = { title: PENDING_DISCLOSURE_CHIP_TITLE, variant: LabelVariant.ORANGE };
